import Alpine from "alpinejs";

// PLUGINS
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import morph from "@alpinejs/morph";
import ui from "@alpinejs/ui";
import dialog from "./plugins/dialog";

import Swiper from 'swiper';
import { Thumbs } from 'swiper/modules';
Swiper.use([ Thumbs ]);

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(morph);
Alpine.plugin(ui);
Alpine.plugin(dialog);

import history from "./plugins/history";
import share from "./plugins/share";

Alpine.plugin(history);
Alpine.plugin(share);

// STORES
import cart from "./stores/cart";
Alpine.store("cart", cart);

// COMPONENTS
import media from "./components/media";
Alpine.data("media", media);

import product from "./components/product";
Alpine.data("product", product);

import productRecommendations from "./components/productRecommendations";
Alpine.data("productRecommendations", productRecommendations);

import numberInput from "./components/numberInput";
Alpine.data("numberInput", numberInput);

import validation from "./components/validation";
Alpine.data("validation", validation);

window.Alpine = Alpine;

// INIT
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    const imageSwiperContainer = document.getElementById('product-image-swiper');
    const thumbsSwiperContainer = document.getElementById('product-thumbs-swiper');
    const imageNextButton = document.getElementById('product-image-next');
    const imagePrevButton = document.getElementById('product-image-prev');

    if (imageSwiperContainer && thumbsSwiperContainer && imageNextButton && imagePrevButton) {
        const thumbsSwiper = new Swiper(thumbsSwiperContainer, {
            spaceBetween: 10,
            slidesPerView: 3,
        });
        const imageSwiper = new Swiper(imageSwiperContainer, {
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
        imageNextButton.addEventListener('click', () => {
            if (thumbsSwiper.allowSlideNext) {
                thumbsSwiper.slideNext();
            }
        });
        imagePrevButton.addEventListener('click', () => {
            if (thumbsSwiper.allowSlidePrev) {
                thumbsSwiper.slidePrev()
            }
        })
    }
})